import ApplicationController from "./application_controller";
import StimulusReflex from "stimulus_reflex";
import $ from "jquery";

export default class extends ApplicationController {
    static targets = ["hm0_output"];

    connect() {

        super.connect();
        StimulusReflex.register(this);
        console.log("Export compatable controller js en cours ..");
        MicroModal.init();
 
 

            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            const export_comptable_id_param = url.searchParams.get("export_comptable_id");

            if (export_comptable_id_param != null) {
                 
                $("#export_comptable_" + export_comptable_id_param + " td").addClass("highlighted-td");
                $("#export_comptable_" + export_comptable_id_param).get(0).scrollIntoView({ behavior: "smooth", block: "center" });
            }
    




    }


  




    get params() {
        return this.data.get("params");
    }

    get current_app() {
        return this.data.get("app");
    }




    get bons_de_commande_id() {
        return this.data.get("bons_de_commandeid");
    }

    get filterrific() {
        return this.data.get("filterrific");
    }

    get page() {
        return this.data.get("page");
    }

    get filter_param_id() {
        return this.data.get("filter-param-id");
    }

    get is_active() {
        return this.data.get("is-active");
    }

    get active_tab() {
        return this.data.get("active-tab");
    }



    get url_solution() {
        return this.data.get("urlsolution");
    }
}